export class TrackerStepsStatusViewModel {
  bcanbr?: number = 0;
  date: string | number | Date;
  grId?: number = 0;
  approachType: string = '';
  trackerSteps: string = '';
  trackerStepSequence: number = 0;
  taskStatusCode: string = '';
  dateModified: string;
  obligationType: string = '';
  stepsDescription: string = '';
  imageUrl?: string;
  taskSle?: number;
  scheduleDate?: string = '';
    state?: string = '';
    comments?: string = '';
}
